export const pageFragment = `
  fragment page on Page {
    _meta {
      ...meta
    }

    title
    hero {
        title
        content
        link_text
        link {
          ...linkable
        }
        image
        mobileImage
        video {
          ...linkable
        }
        cta_video {
          ...linkable
        }
        safari_cta_video {
          ...linkable
        }
    }
   
    onboarding_button_link {
      ...linkable
    }

    render_as_new_hero
    
    parent {
      ...linkable
    }

    page_title
    seo_title
    seo_description
    seo_image
  }
`
